import { createApp, markRaw } from "vue";
import App from "./App.vue";
import router from "./router";
import "@mdi/font/css/materialdesignicons.css";

// pinia
import { createPinia } from "pinia";
// import axiosAPIStore from "code-library/store/axiosAPI.js";

const pinia = createPinia();

pinia.use(({ store }) => {
  store.$router = markRaw(router)
});


// Vuetify
import "vuetify/styles";
import { createVuetify } from "vuetify";
import * as components from "vuetify/components";
import * as directives from "vuetify/directives";

const vuetify = createVuetify({
  components,
  directives,
  icons: {
    defaultSet: "mdi",
  },
});

const app = createApp(App).use(pinia).use(router).use(vuetify);
app.mount("#app");
